module.exports = __webpack_public_path__ + "img/system7-details.e091f59a.png";